/* SOFIZARE – staffelkorting-balk: live bijwerken na elke winkelwagenwijziging (Focal 'cart:updated' / 'variant:added').
   Focal rendert drawer/winkelwagenpagina meestal zelf opnieuw (Liquid); dit script houdt de balk ook correct als dat niet gebeurt. */
(function(){
  function fmt(cents,format){
    cents=Math.round(cents);
    function d(n,prec,th,dec){var s=(n/100).toFixed(prec).split('.');s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);return s[1]?s[0]+dec+s[1]:s[0];}
    var m=/\{\{\s*(\w+)\s*\}\}/.exec(format||'€{{amount_with_comma_separator}}'), v;
    switch(m?m[1]:'amount_with_comma_separator'){
      case 'amount': v=d(cents,2,',','.');break;
      case 'amount_no_decimals': v=d(cents,0,',','.');break;
      case 'amount_no_decimals_with_comma_separator': v=d(cents,0,'.',',');break;
      case 'amount_with_apostrophe_separator': v=d(cents,2,"'",'.');break;
      case 'amount_with_space_separator': v=d(cents,2,' ',',');break;
      default: v=d(cents,2,'.',',');
    }
    return (format||'€{{amount_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/,v);
  }
  function render(bar,sub){
    var t=bar.dataset.t.split(',').map(Number), p=bar.dataset.p.split(','), f=bar.dataset.moneyFormat, msg;
    var tmp=document.createElement('textarea');
    function tpl(k){tmp.innerHTML=bar.dataset[k];return tmp.value;}
    if(sub>=t[2]) msg=tpl('msgMax').replace('__P__',p[2]);
    else if(sub>=t[1]) msg=tpl('msgBetween').replace('__C__',p[1]).replace('__A__',fmt(t[2]-sub,f)).replace('__N__',p[2]);
    else if(sub>=t[0]) msg=tpl('msgBetween').replace('__C__',p[0]).replace('__A__',fmt(t[1]-sub,f)).replace('__N__',p[1]);
    else msg=tpl('msgBelow').replace('__A__',fmt(t[0]-sub,f)).replace('__P__',p[0]);
    bar.querySelector('[data-sz-bar-text]').textContent=msg;
    var pr=Math.min(100,sub*100/t[2]);
    bar.querySelector('[data-sz-bar-fill]').style.width=pr+'%';
    bar.querySelector('[role=progressbar]').setAttribute('aria-valuenow',Math.round(pr));
    bar.querySelectorAll('.sz-bar__marker').forEach(function(mk){mk.classList.toggle('is-reached',sub>=t[+mk.dataset.i]);});
    bar.classList.toggle('is-active',sub>=t[0]);
  }
  function subtotal(cart){return (cart.items||[]).reduce(function(s,i){return s+(i.original_line_price||0);},0);}
  function refresh(cart){
    var bars=document.querySelectorAll('[data-sz-bar]'); if(!bars.length) return;
    var go=function(c){var s=subtotal(c);bars.forEach(function(b){render(b,s);});};
    if(cart&&cart.items&&cart.items.length&&cart.items[0].original_line_price!==undefined) go(cart);
    else fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(go).catch(function(){});
  }
  ['cart:updated','variant:added','cart:refresh'].forEach(function(ev){
    document.addEventListener(ev,function(e){setTimeout(function(){refresh(e.detail&&e.detail.cart);},50);});
  });
})();
